export default __webpack_public_path__ + "static/media/doctorThumb2.9aa5edb2.svg";